import axios from "axios";
import apiURI from "./Api";

export default class UserAtecoService {
  async getAtecoCodes(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/user-ateco/get-ateco-codes`,
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  }

  async assignAtecoCode(token, payload) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/user-ateco/assign-ateco-code`,
      data: payload,
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  }

  async deleteAtecoCode(token, atecoId) {
    const response = await axios({
      method: "delete",
      url: `${apiURI}/user-ateco/delete-ateco-code/${atecoId}`,
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  }
}
